import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { BaseProviderService } from './base-provider.service';
import {EnvioCnds} from "../aplicacao/models/envioCnds.model";

@Injectable({
  providedIn: 'root'
})
export class MotivosPropostaService extends BaseProviderService {

  protected module = 'Proposta';

  constructor(protected http: HttpClient) {
    super(http);
   }

  motivosCancelarProposta(): Observable<any> {
    return this.http.get<any>(this.getUrl(this.v1, this.module, ['Parceiro', 'MotivoReprovacao']));
  }
}
